var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9053 9.48827C32.7111 10.3742 29.6506 11.6855 26.8058 13.3869L19.0008 8.61761L8.45276 19.5123L13.4378 27.171C11.8216 30.0512 10.5985 33.1349 9.80112 36.3398L0.909668 38.4895L1.1177 53.5449L10.0708 55.4403C10.9573 58.6318 12.2686 61.6897 13.9695 64.532L9.20013 72.3294L19.987 82.8774L27.6919 77.8923C30.5689 79.5112 33.6501 80.737 36.853 81.5367L39.0027 90.4282L54.1351 90.2125L56.0305 81.2671C59.2113 80.3779 62.2588 79.0667 65.0915 77.3684L72.8888 82.1377L83.4753 71.2815L78.4903 63.6229C80.106 60.7416 81.3315 57.6583 82.1347 54.454L91.0107 52.3352L90.795 37.2105L81.8496 35.3151C80.958 32.1338 79.6442 29.0864 77.9432 26.2541L82.7125 18.4568L71.8641 7.87024L64.1977 12.8553C61.3206 11.2364 58.2395 10.0107 55.0366 9.21089L52.8561 0.327148L37.793 0.542885L35.9053 9.48827ZM45.9833 64.2778C56.4088 64.2778 64.8603 55.8263 64.8603 45.4008C64.8603 34.9753 56.4088 26.5238 45.9833 26.5238C35.5578 26.5238 27.1063 34.9753 27.1063 45.4008C27.1063 55.8263 35.5578 64.2778 45.9833 64.2778Z",
    fill: "#43927C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenGear);
export default __webpack_public_path__ + "static/media/green-gear.e16ef102fe37198f40c1298cb3e7b450.svg";
export { ForwardRef as ReactComponent };